import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.INSERIR_NOVO_FORNECEDOR]({ state }) {
		await api.alterarFornecedor.inserirNovoFornecedor(state)
	},

	async [actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.BUSCAR_FORNECEDORES](context, idItemAta) {
		const { data } = await api.alterarFornecedor.buscarFornecedores(idItemAta)
		return data
	},

	async [actionTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.BUSCAR_FILIAIS](context, idFornecedor) {
		const { data } = await api.alterarFornecedor.buscarFiliais(idFornecedor)
		return data
	},
}
